import * as _ from 'lodash';
import type { VoidFunctionComponent } from 'react';

import { Category } from '../../../../shared/issuesV2';
import { isQualityEnabled } from '../../../helpers/features/quality';
import { isSecurityEnabled } from '../../../helpers/features/security';
import Button from '../../generic/Button/Button';
import { icons } from '../../generic/Icon/icons';
import { Icon } from '../../generic/Icon/index';
import { Menu, MenuRadioGroup, RadioMenuItem } from '../../generic/Menu/index';

type Props = {
  category?: Category;
  setCategory: (category: Category | undefined) => void;
  isDisabled?: boolean;
};

const issueTypeOptions = _.compact([
  { value: undefined, label: 'All issues' },
  { value: Category.Licensing, label: 'Licensing issues' },
  isSecurityEnabled() && { value: Category.Vulnerability, label: 'Security issues' },
  isQualityEnabled() && { value: Category.Quality, label: 'Quality issues' },
]);

const IssueFilter: VoidFunctionComponent<Props> = ({ category, setCategory, isDisabled }) => {
  // Don't show this if the user only has one category of issues.
  if (issueTypeOptions.length === 2) {
    return null;
  }

  const selectedOption = issueTypeOptions.find((opt) => opt.value === category);
  return (
    <Menu
      menuButton={
        <Button type="secondary" onClick={_.noop} isDisabled={isDisabled}>
          {selectedOption?.label} <Icon icon={icons.chevronDown} />
        </Button>
      }
      direction="bottom"
    >
      <MenuRadioGroup
        value={category}
        onRadioChange={(e) => setCategory(e.value)}
      >
        {issueTypeOptions.map(({ value, label }) => (
          <RadioMenuItem key={label} value={value}>{label}</RadioMenuItem>
        ))}
      </MenuRadioGroup>
    </Menu>

  );
};

export default IssueFilter;
